import { ReportAccessType } from "@entrilia/shared/api/reportAccessTypes.ts";
import { getAllowedAccessByPermissions } from "@entrilia/shared/utilities/accessHelper.ts";
import type {
  GroupBasedAuthorization,
  GroupForSharing,
  UserBasedAuthorization,
  UserForSharing,
} from "../../../../../../../../../api/types/svTypes.ts";

export type GroupItem = {
  groupId: string;
  name: string;
  memberCount: number;
  access: ReportAccessType;
};

export type UserItem = {
  userId: string;
  name: string;
  email: string;
  access: ReportAccessType;
  isCurrentUser: boolean;
  allowedAccesses: ReportAccessType[];
};

export function buildAuthorizedGroupItems(
  authorizedGroups: GroupBasedAuthorization[],
  allGroups: GroupForSharing[]
): GroupItem[] {
  return authorizedGroups
    .map((authGroup) => {
      const group = allGroups.find((g) => g.groupId === authGroup.groupId);
      if (!group) return null;
      return {
        groupId: group.groupId,
        name: group.name,
        memberCount: group.memberCount,
        access: authGroup.access,
      };
    })
    .filter((item): item is GroupItem => item !== null);
}

export function buildAuthorizedUserItems(
  authorizedUsers: UserBasedAuthorization[],
  allUsers: UserForSharing[],
  currentUserId: string,
  currentUserAccess: ReportAccessType
): UserItem[] {
  const result: UserItem[] = [];

  authorizedUsers.forEach((authUser) => {
    const user = allUsers.find((u) => u.userId === authUser.userId);
    if (!user) {
      return;
    }

    const item: UserItem = {
      userId: user.userId,
      name: user.name,
      email: user.email,
      access: authUser.access,
      allowedAccesses: getAllowedAccessByPermissions(user.permissions, currentUserAccess),
      isCurrentUser: user.userId === currentUserId,
    };

    if (authUser.access === ReportAccessType.Owner) {
      result.unshift(item);
    } else {
      result.push(item);
    }
  });

  return result;
}
